var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "record-overview position-relative loading-content-container",
    },
    [
      _vm.isLoading
        ? _c(
            "div",
            {
              staticClass: "loading-overlay d-flex justify-content-center pt-5",
            },
            [_c("csp-loading-indicator")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "div",
            [
              _c(
                "b-row",
                { staticClass: "mb-4" },
                [
                  _vm.isRegressClaim
                    ? [
                        _c("csp-record-claimant", {
                          attrs: { "claimant-data": _vm.claimantData, cols: 4 },
                        }),
                        _vm._v(" "),
                        _c("csp-record-defendant", {
                          attrs: {
                            cols: 5,
                            "defendant-data": _vm.defendantData,
                          },
                        }),
                      ]
                    : _c("csp-record-customer-and-vehicle", {
                        attrs: {
                          "claim-type": _vm.claimType,
                          cols: 9,
                          "customer-data": _vm.customerData,
                          "vehicle-data": _vm.vehicleData,
                        },
                      }),
                  _vm._v(" "),
                  _c(
                    "csp-desktop-info-card",
                    {
                      attrs: {
                        cols: 3,
                        icon: "inticon-autoclaim_document_accident",
                        title: "Dokumente",
                      },
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-col", { attrs: { cols: "12" } }, [
                            _vm.filesData.groups.length === 0
                              ? _c("div", { staticClass: "font-weight-bold" }, [
                                  _vm._v(
                                    "\n                            Noch keine Dokumente vorhanden\n                        "
                                  ),
                                ])
                              : _c(
                                  "div",
                                  _vm._l(
                                    _vm.filesData.groups,
                                    function (group) {
                                      return _c(
                                        "div",
                                        { key: group.id, staticClass: "mb-3" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "font-weight-bold mb-1",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(group.name) +
                                                  "\n                                "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(group.files, function (file) {
                                            return _c(
                                              "div",
                                              {
                                                key: file.id,
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.downloadFile(
                                                      file.id
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href: _vm.buildFileDownloadUrl(
                                                        file.id
                                                      ),
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(file.name))]
                                                ),
                                              ]
                                            )
                                          }),
                                        ],
                                        2
                                      )
                                    }
                                  ),
                                  0
                                ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mb-4" },
                [
                  _vm.isRegressClaim
                    ? _c("csp-record-customer-and-vehicle", {
                        attrs: {
                          "claim-type": _vm.claimType,
                          cols: 9,
                          "customer-data": _vm.customerData,
                          "vehicle-data": _vm.vehicleData,
                        },
                      })
                    : _vm.adversaryData
                    ? _c(
                        "csp-desktop-info-card",
                        {
                          attrs: {
                            cols: 6,
                            icon: "inticon-autoclaim_insurance",
                            title: "Gegner und Versicherung",
                          },
                        },
                        [
                          _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { cols: "6" } }, [
                                _c("div", { staticClass: "focus-text" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.adversaryData.fullNameWithSalutation
                                      ) +
                                      "\n                        "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.adversaryData.address) +
                                      "\n                        "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "6" } },
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c("b-col", { attrs: { cols: "6" } }, [
                                        _vm.adversaryData.mobile
                                          ? _c("div", [
                                              _c("i", {
                                                staticClass:
                                                  "inticon-phone value-icon",
                                              }),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.adversaryData.mobile
                                                  )
                                                ),
                                              ]),
                                            ])
                                          : _vm._e(),
                                      ]),
                                      _vm._v(" "),
                                      _c("b-col", { attrs: { cols: "6" } }, [
                                        _vm.adversaryData.phone
                                          ? _c("div", [
                                              _c("i", {
                                                staticClass:
                                                  "inticon-phone value-icon",
                                              }),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.adversaryData.phone
                                                  )
                                                ),
                                              ]),
                                            ])
                                          : _vm._e(),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("b-row", [
                                    _vm.adversaryData.email
                                      ? _c("div", [
                                          _c("i", {
                                            staticClass: "messages value-icon",
                                          }),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.adversaryData.email)
                                            ),
                                          ]),
                                        ])
                                      : _vm._e(),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("hr"),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c("csp-license-place", {
                                    attrs: {
                                      region:
                                        _vm.adversaryData.licensePlate.region,
                                      rest: _vm.adversaryData.licensePlate.rest,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("b-col", { attrs: { cols: "4" } }, [
                                _c("div", { staticClass: "font-weight-bold" }, [
                                  _vm._v(
                                    "\n                            Versicherung\n                        "
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm.adversaryData.insurance.companyName
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.adversaryData.insurance
                                              .companyName
                                          ) +
                                          ",\n                            " +
                                          _vm._s(
                                            _vm.adversaryData.insurance.address
                                          ) +
                                          "\n                        "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c("b-col", { attrs: { cols: "4" } }, [
                                _vm.adversaryData.insurance.phone
                                  ? _c("div", [
                                      _c("i", {
                                        staticClass: "inticon-phone value-icon",
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.adversaryData.insurance.phone
                                          )
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.adversaryData.insurance.reference
                                  ? _c("div", [
                                      _c("i", {
                                        staticClass:
                                          "inticon-documents value-icon",
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.adversaryData.insurance
                                              .reference
                                          )
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.comprehensiveInsuranceData
                    ? _c(
                        "csp-desktop-info-card",
                        {
                          attrs: {
                            cols: 6,
                            icon: "inticon-autoclaim_insurance",
                            title: "Versicherung",
                          },
                        },
                        [
                          _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { cols: "8" } }, [
                                _c("div", { staticClass: "font-weight-bold" }, [
                                  _vm._v(
                                    "\n                            Versicherung\n                        "
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm.comprehensiveInsuranceData.companyName
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.comprehensiveInsuranceData
                                              .companyName
                                          )
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.comprehensiveInsuranceData
                                              .address
                                          ) +
                                          "\n                        "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c("b-col", { attrs: { cols: "4" } }, [
                                _vm.comprehensiveInsuranceData.phone
                                  ? _c("div", [
                                      _c("i", {
                                        staticClass: "inticon-phone value-icon",
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.comprehensiveInsuranceData.phone
                                          )
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.comprehensiveInsuranceData.insuranceNumber
                                  ? _c("div", [
                                      _c("i", {
                                        staticClass:
                                          "inticon-documents value-icon",
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.comprehensiveInsuranceData
                                              .insuranceNumber
                                          )
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "mt-3" },
                            [
                              _c("b-col", { attrs: { cols: "6" } }, [
                                _c("div", [
                                  _vm._v(
                                    "\n                            Selbstbeteiligung\n                        "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-between w-100",
                                  },
                                  [
                                    _c("span", [_vm._v("Vollkasko:")]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.comprehensiveInsuranceData
                                            .copaymentFully
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [_vm._v("Teilkasko:")]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.comprehensiveInsuranceData
                                            .copaymentPartially
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showAccidentData
                    ? _c(
                        "csp-desktop-info-card",
                        {
                          attrs: {
                            cols: 3,
                            icon: "inticon-autoclaim_pin",
                            title: "Unfallort",
                          },
                        },
                        [
                          _c(
                            "b-row",
                            [
                              _c("b-col", [
                                _c("div", { staticClass: "font-weight-bold" }, [
                                  _vm._v(
                                    "\n                            Unfallort\n                        "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.recordData.accidentAddress) +
                                      "\n                        "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("div", { staticClass: "font-weight-bold" }, [
                                  _vm._v(
                                    "\n                            Unfalldatum\n                        "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.recordData.accidentDate) +
                                      "\n                        "
                                  ),
                                ]),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "csp-desktop-info-card",
                    {
                      attrs: {
                        cols: 3,
                        icon: "inticon-autoclaim_billing",
                        title: "Rechnungen",
                      },
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _c("div", { staticClass: "invoice-meters" }, [
                              _c(
                                "div",
                                { staticClass: "invoice-meter" },
                                [
                                  _c("span", { staticClass: "title" }, [
                                    _vm._v("Reparatur"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "percentage" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.costUnitsData.repair.percentPayed
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "amount" }, [
                                    _vm._v(
                                      "Gesamt: " +
                                        _vm._s(
                                          _vm.costUnitsData.repair.netFormatted
                                        )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("b-progress", {
                                    staticClass: "repair-bar",
                                    attrs: {
                                      height: "8px",
                                      max: _vm.costUnitsData.repair.barMax,
                                      value: _vm.costUnitsData.repair.barValue,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "invoice-meter" },
                                [
                                  _c("span", { staticClass: "title" }, [
                                    _vm._v("Mietwagen"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "percentage" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.costUnitsData.rentVehicle
                                          .percentPayed
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "amount" }, [
                                    _vm._v(
                                      "Gesamt: " +
                                        _vm._s(
                                          _vm.costUnitsData.rentVehicle
                                            .netFormatted
                                        )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("b-progress", {
                                    staticClass: "rentVehicle",
                                    attrs: {
                                      height: "8px",
                                      max: _vm.costUnitsData.rentVehicle.barMax,
                                      value:
                                        _vm.costUnitsData.rentVehicle.barValue,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mb-4" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("csp-record-notes", {
                        attrs: {
                          "default-page-options": [5],
                          "default-per-page": 5,
                          "disable-filters": true,
                          "disable-pagination": true,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "below-body",
                              fn: function () {
                                return [
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "Anzeige der 5 neuesten Nachrichten"
                                    ),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          2242672656
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.firmRemarksData
                ? _c(
                    "b-row",
                    { staticClass: "mb-4" },
                    [
                      _c(
                        "csp-desktop-info-card",
                        {
                          attrs: {
                            cols: 12,
                            icon: "inticon-autoclaim_info",
                            title: "Firmeninfos",
                          },
                        },
                        [
                          _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { cols: "2" } }, [
                                _c("p", [
                                  _c("b", [_vm._v("Kommunikation RA")]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticStyle: { "white-space": "pre-line" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.firmRemarksData
                                            .remarksRequestLawyer
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("b-col", { attrs: { cols: "2" } }, [
                                _c("p", [
                                  _c("b", [_vm._v("Kommunikation Service")]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticStyle: { "white-space": "pre-line" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.firmRemarksData
                                            .remarksCommunicationService
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("b-col", { attrs: { cols: "2" } }, [
                                _c("p", [
                                  _c("b", [
                                    _vm._v("Kommunikation Buchhaltung"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticStyle: { "white-space": "pre-line" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.firmRemarksData.remarksAccounting
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("b-col", { attrs: { cols: "2" } }, [
                                _c("p", [
                                  _c("b", [
                                    _vm._v("Kommunikation Geschädigter"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticStyle: { "white-space": "pre-line" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.firmRemarksData.remarksAdversary
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("b-col", { attrs: { cols: "2" } }, [
                                _c("p", [
                                  _c("b", [_vm._v("Partnerversicherung")]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticStyle: { "white-space": "pre-line" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.firmRemarksData
                                            .remarksPartnerInsurance
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("b-col", { attrs: { cols: "2" } }, [
                                _c("p", [_c("b", [_vm._v("Sonstiges")])]),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticStyle: { "white-space": "pre-line" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.firmRemarksData.remarksOther
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }